import { put, call } from 'redux-saga/effects';
import { saveAs } from 'file-saver';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/report';
import { get, post, postFile } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getListReports({ payload }) {
  try {
    yield put(action.getListReportsSuccess());
  } catch (error) {
    yield put(action.getListReportsFail());
  }
}

export function* getReportCreate({ payload }) {
  try {
    // const report = yield call(postFile, payload.url, {
    //   plantId: payload.plantId,
    //   dateFrom: payload.dateFrom,
    //   dateTo: payload.dateTo
    // });
    // const file = new Blob([report], { type: 'application/pdf' });
    // saveAs(file, 'report.pdf');

    if (payload.reportType) {
      // eslint-disable-next-line no-nested-ternary
      const reportParams = (payload.reportType === 'HOLDER_REPORT')
        ? {
          plantId: payload.plantId,
          dateFrom: payload.dateFrom,
          dateTo: payload.dateTo,
          showExist: payload.showExist,
          productGroup: payload.productGroup,
          docId: payload.docId
        } : (payload.reportType === 'DOC_SIGN_REGISTRY') ? {
          plantId: payload.plantId,
          dateFrom: payload.dateFrom,
          dateTo: payload.dateTo,
          statusFilter: payload.statusFilter,
          productGroup: payload.productGroup,
          userId: payload.user,
          docTypeNumId: payload.act
        } : (payload.reportType === 'DOC_SIGN_PRINTED_REGISTRY') ? {
          plantId: payload.plantId,
          dateFrom: payload.dateFrom,
          dateTo: payload.dateTo,
          statusFilter: payload.statusFilter,
          docTypeNumId: payload.act
        } : ((payload.reportType === 'INVENTORY'
              || payload.reportType === 'INV_3'
              || payload.reportType === 'OVER_STORAGE_REPORT'
              || payload.reportType === 'FINISHED_PRODUCT_REPORT') ? {
            plantId: payload.plantId,
            date: payload.date
          } : (payload.reportType === 'PIECES_ON_HOLD_REPORT') ? {
            plantIds: payload.plantIds,
            dateFrom: payload.dateFrom,
            dateTo: payload.dateTo
          } : (payload.reportType === 'PROCESSING_REPORT') ? {
            plantId: payload.plantId,
            dross: payload.dross,
            dateFrom: payload.dateFrom,
            dateTo: payload.dateTo
          } : {
            plantId: payload.plantId,
            dateFrom: payload.dateFrom,
            dateTo: payload.dateTo
          });
      if (payload.printFormat === 'PDF') {
        const data = window.btoa(unescape(encodeURIComponent(JSON.stringify({
          restMethod: 'postFile',
          url: payload.url,
          args: {
            reportType: payload.reportType,
            printFormat: 'PDF',
            reportParams
          }
        }))));
        const newWindow = window.open(`/pdf-viewer/${data}`, '_blank');
        newWindow.opener = null;
      } else if (payload.printFormat === 'EXCEL') {
        const report = yield call(postFile, payload.url, {
          reportType: payload.reportType,
          printFormat: 'EXCEL',
          reportParams
        });
        const file = new Blob([report.data], { type: 'application/octet-stream' });
        saveAs(file, report.headers['content-disposition'].replace('attachment; filename=', ''));
      } else if (payload.printFormat === 'ZIP') {
        const report = yield call(postFile, payload.url, reportParams);
        const file = new Blob([report.data], { type: 'application/octet-stream' });
        const fileName = report.headers['content-disposition'].split('filename=')[1];
        yield call(saveAs, file, fileName);
      }
    } else {
      const data = window.btoa(unescape(encodeURIComponent(JSON.stringify({
        restMethod: 'postFile',
        url: payload.url,
        args: {
          plantId: payload.plantId,
          dateFrom: payload.dateFrom,
          dateTo: payload.dateTo
        }
      }))));
      const newWindow = window.open(`/pdf-viewer/${data}`, '_blank');
      newWindow.opener = null;
    }

    yield put(action.getReportCreateSuccess());
  } catch (error) {
    let errorText = '';

    if (error.response.data instanceof Blob) {
      const responseErrorText = yield error.response.data.text();
      errorText = JSON.parse(responseErrorText);
    }

    yield put(action.getReportCreateFail(error.response.data));
    yield put(
      modalErrorOpen({
        message: error.response.data.message || errorText.message || formatMessage('textError').reportCreateError,
        techInfo: '',
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

export function* getReportCreateNew({ payload }) {
  try {
    const data = window.btoa(unescape(encodeURIComponent(JSON.stringify({
      restMethod: 'postFile',
      url: '/report',
      args: payload
    }))));
    const newWindow = window.open(`/pdf-viewer/${data}`, '_blank');
    newWindow.opener = null;
    yield put(action.getReportCreateSuccess());
  } catch (error) {
    yield put(action.getReportCreateFail(error.response.data));
  }
}

export function* getReportTypes({ payload }) {
  try {
    const response = yield call(get, `/report/report-types/${payload.plantId}`);
    console.log(`/report/report-types/${payload.plantId}`);
    yield put(action.getReportTypesSuccess(
      response.map((item) => ({
        key: Object.keys(item)[0],
        value: item[Object.keys(item)[0]]
      })).filter((item) => item.type)
    ));
  } catch (error) {
    yield put(action.getReportTypesFail(error.response.data));
  }
}

export function* getReportProductTypes({ payload }) {
  try {
    const response = yield call(post, `/report/product-types/${payload.plantId}`);
    yield put(action.getReportProductTypesSuccess(
      response.map((item) => ({
        key: item[Object.keys(item)[0]],
        value: item[Object.keys(item)[1]]
      }))
    ));
  } catch (error) {
    yield put(action.getReportProductTypesFail(error.response.data));
  }
}

export function* getReportUsers({ payload }) {
  try {
    const response = yield call(post, `/report/users/${payload.plantId}`);
    yield put(action.getReportUsersSuccess(
      response.map((item) => ({
        key: item[Object.keys(item)[0]],
        value: item[Object.keys(item)[1]]
      })).sort((a, b) => {
        if (a.value < b.value) {
          return -1;
        }
        if (a.value > b.value) {
          return 1;
        }
        return 0;
      })
    ));
  } catch (error) {
    yield put(action.getReportUsersFail(error.response.data));
  }
}
